export const postToLabel = "hBY7Wb";
export default {postToLabel};